import debounce from 'lodash/debounce';
import React, { useCallback, useEffect, useRef } from 'react';
import { useStyleOverrides } from '../../hooks/use-style-overrides';
import More from './more';
export const CnScrollView = React.forwardRef((props, ref) => {
    const { id, children, hasMore, loadMore = null, scrollEventThrottle = 500, moreRender, style, } = props;
    const overrides = useStyleOverrides(props, 'scroll-view');
    const $ref = useRef(null);
    const handler = useCallback(debounce((entries) => {
        if (entries[0].isIntersecting) {
            if (hasMore) {
                loadMore && loadMore();
            }
        }
    }, scrollEventThrottle), [loadMore]);
    useEffect(() => {
        const interInstance = new window.IntersectionObserver(handler);
        if (!$ref.current) {
            return;
        }
        interInstance.observe($ref.current);
        return () => {
            interInstance.disconnect();
        };
    }, [handler]);
    const styledScrollView = {
        ...style,
        '--scroll-more-padding-top': 'var(--s-3)',
        '--scroll-more-padding-bottom': 'var(--s-3)',
        '--scroll-more-color': 'var(--m-color-primary)',
        overflow: 'auto',
        height: props.height ? `${props.height}px` : 'auto',
    };
    return (React.createElement("div", { ...overrides, ref: ref, id: id, style: styledScrollView },
        children,
        hasMore && React.createElement(More, { ref: $ref, moreRender: moreRender })));
});
CnScrollView.defaultProps = {
    scrollEventThrottle: 500,
};
CnScrollView.displayName = 'CnScrollView';
export * from './types';
